


export const userRoleList = [
    {
        label: 'ADMIN',
        value: 'ADMIN',
    },
    {
        label: 'MD',
        value: 'MD',
    },
    {
        label: 'BOD',
        value: 'BOD',
    },
    {
        label: 'TELECALLER',
        value: 'TELECALLER',
    },
    {
        label: 'MARKETING EXECUTIVE',
        value: 'MARKETING EXECUTIVE',
    },
    {
        label: 'FIELD WORKER',
        value: 'FIELD WORKER',
    },
    {
        label: 'LEAD UPLOADER',
        value: 'LEAD UPLOADER',
    },
    {
        label: 'CMO',
        value: 'CMO',
    }
]